module.exports = __webpack_public_path__ + "img/jishutianqi.7536e482.png";